import React from "react";
import CustomCards from "../../../../containers/rechargeSales/sales/component/customCard";
import Spinner from "../../../../components/presentationals/Spinner";
import TabPanel from "../../../../containers/rechargeSales/sales/component/tabPanel";
import Error from "../../../../components/Error/index";

function PrimarySalesView(props) {
  let {
    mainHandleChange,
    rechargeSalesObj,
    mainValue,
    data,
    theme,
    body,
    headerUnit,
    rechargeSalesCsvLoading,
    moduleName,
    section,
  } = props;

  return (
    <>
      {rechargeSalesObj.loading ? (
        <Spinner />
      ) : data ? (
        <>
          <ul className="nav nav-pills tabbtndiv text-center">
            {Object.entries(data.salesWrapper).map((value, index) => {
              return (
                <li key={index}>
                  <a
                    data-toggle="pill"
                    onClick={() => {
                      mainHandleChange(value, index);
                    }}
                    href={`#rsd${index + 1}`}
                    className={mainValue === index ? "active" : ""}
                  >
                    {value[0]}
                  </a>
                </li>
              );
            })}
          </ul>
          {Object.entries(data.salesWrapper).map((value, index) => {
            return (
              <TabPanel
                key={index}
                value={mainValue}
                index={index}
                dir={theme.direction}
              >
                <CustomCards
                  data={value[1]}
                  tileName={props.tileName}
                  csvUrl={props.csvUrl}
                  isCsvActive={props.isCsvActive}
                  mainValue={mainValue}
                  filterValue={props.filterValue}
                  body={body}
                  id={props.id}
                  headerSelectedDateFrom={props.startDate}
                  headerSelectedDateTo={props.endDate}
                  headerUnit={headerUnit}
                  rechargeSalesCsvLoading={rechargeSalesCsvLoading}
                  dashboardName={moduleName}
                  viewName={section}
                />
              </TabPanel>
            );
          })}
        </>
      ) : (
        <Error error={rechargeSalesObj.error} />
      )}
    </>
  );
}
export default PrimarySalesView;
